// 3_pages/blog.js
// Blog post pages (body.in-blog.type-post): flags pre-August-2024 posts as
// "old-blog"; for newer posts builds the article nav (table of contents),
// replaces ##AUTOR## placeholders with author boxes, and fetches/injects
// related blogs, products and category blocks from ##BLOG##/##PRODUKT##/
// ##KATEGORIE## placeholder paragraphs. Uses jQuery ($) on purpose.

export function init() {
	if (!(document.body.classList.contains("in-blog") && document.body.classList.contains("type-post"))) return;

	if (!window.NAT?.media) {
		console.warn("[NAT] blog.js: window.NAT.media missing — check load order");
		return;
	}

	document.addEventListener("DOMContentLoaded", function () {
		oldBlog();
		function oldBlog() {
			const timeElement = $(".news-item-detail time[datetime]");
			// NOTE: kept from original — if the time[datetime] element is missing, dateStr is undefined and split() throws
			const dateStr = timeElement.attr("datetime");
			const [day, month, year] = dateStr.split(".").map(Number);
			const date = new Date(year, month - 1, day);
			const comparisonDate = new Date(2024, 6, 31);

			if (date < comparisonDate) {
				$("body").addClass("old-blog");
			} else {
				articleNav();
				blogAutor();
				fetchAndAppendRelatedBlogs();

				fetchAndAppendBlogProducts3();
				fetchAndAppendBlogProducts2();
				fetchAndAppendBlogProducts1();
				fetchAndAppendBlogProducts();

				fetchAndAppendBlogCategory();
			}
		}

		function blogAutor() {
			$("#content p").each(function () {
				if (/##AUTOR##KATEŘINAT/i.test($(this).text())) {
					if (document.body.classList.contains("cs")) {
						$(this).replaceWith(
							'<div id="blog-author"><div class="author-image"><img src="https://www.natima.cz/user/documents/upload/Blog/autori/KaterinaTranova.webp" alt="Kateřina" width="500" height="500"></div><div class="author-text"><p class="author-label">Autor</p><p class="author-name">Kateřina</p><div class="expandale author-text"><div class="expanding"><p>Zajímám se o zdravý životní styl, sport, kosmetiku a zdravou stravu. Mým cílem je inspirovat ostatní, aby pečovali o své tělo i mysl a stali se tou nejlepší verzí sebe samých. Pravidelně se věnuji různým sportovním aktivitám a hledám nové cesty, jak optimalizovat svou fyzickou kondici i duševní pohodu.</p><p>Zdravá strava je pro mě klíčovým prvkem, který podporuje mé zdraví a energii. Kromě sportu a výživy mě baví objevovat nové kosmetické trendy a produkty, které podporují přirozenou krásu a zdraví. Ve volném čase si ráda přečtu dobrou knihu, která mi poskytne nejen odpočinek, ale i nové poznatky. Na blogu se s vámi podělím o své zkušenosti, tipy a rady, jak žít zdravěji a spokojeněji.</p></div></div></div></div>',
						);
					}
					if (document.body.classList.contains("sk")) {
						$(this).replaceWith(
							'<div id="blog-author"><div class="author-image"><img src="https://www.natima.cz/user/documents/upload/Blog/autori/KaterinaTranova.webp" alt="Kateřina" width="500" height="500"></div><div class="author-text"><p class="author-label">Autor</p><p class="author-name">Kateřina</p><div class="expandale author-text"><div class="expanding"><p>Zaujímam sa o zdravý životný štýl, šport, kozmetiku a zdravú stravu. Môj cieľ je inšpirovať ostatných, aby sa starali o svoje telo aj myseľ a stali sa tou najlepšou verziou seba samých. Pravidelne sa venujem rôznym športovým aktivitám a hľadám nové cesty, ako optimalizovať svoju fyzickú kondíciu aj duševnú pohodu.</p><p>Zdravá strava je pre mňa kľúčovým prvkom, ktorý podporuje moje zdravie a energiu. Okrem športu a výživy ma baví objavovať nové kozmetické trendy a produkty, ktoré podporujú prirodzenú krásu a zdravie. Vo voľnom čase si rada prečítam dobrú knihu, ktorá mi poskytne nielen oddych, ale aj nové poznatky. Na blogu sa s vami podelím o svoje skúsenosti, tipy a rady, ako žiť zdravšie a spokojnejšie.</p></div></div></div></div>',
						);
					}
					if (document.body.classList.contains("pl")) {
						$(this).replaceWith(
							'<div id="blog-author"><div class="author-image"><img src="https://www.natima.cz/user/documents/upload/Blog/autori/KaterinaTranova.webp" alt="Kasia" width="500" height="500"></div><div class="author-text"><p class="author-label">Autor</p><p class="author-name">Kasia</p><div class="expandale author-text"><div class="expanding"><p>Interesuję się zdrowym stylem życia, sportem, metodami pielęgnacji skóry i zdrowym odżywianiem. Moim celem jest inspirowanie innych do dbania o ciało i umysł oraz stawania się najlepszą wersją siebie. Regularnie uprawiam różne sporty i poszukuję nowe sposoby na poprawę kondycji fizycznej i zdrowia psychicznego.</p><p>Zdrowa dieta jest dla mnie kluczowym elementem wspierającym moje zdrowie i energię. Oprócz sportu i zdrowego odżywiania lubię odkrywać nowe trendy w branży kosmetycznej oraz produkty, które promują naturalne piękno i zdrowie. W wolnym czasie lubię przeczytać dobrą książkę, która nie tylko pozwala mi się zrelaksować, ale także dowiedzieć się czegoś nowego. Na blogu będę dzielić się z Tobą moimi doświadczeniami, wskazówkami i poradami dotyczącymi tego, jak żyć zdrowszym i szczęśliwszym życiem.</p></div></div></div></div>',
						);
					}
				}

				if (/##AUTOR##BARBORAP/i.test($(this).text())) {
					if (document.body.classList.contains("cs")) {
						$(this).replaceWith(
							`
<div id="blog-author">
	<div class="author-image"> <img src="https://www.natima.cz/user/documents/upload/Blog/autori/barbora_p_natima.jpg"
			alt="Barbora P." width="400" height="400"></div>
	<div class="author-text">
		<p class="author-label">Autor</p>
		<p class="author-name">Barbora P.</p>
		<div class="expandale author-text">
			<div class="expanding">
				<p>Zajímám se o cestu ke zdraví a pohodě především přirozenou cestou. Objevuji síly bylinek, principy
					tradiční čínské medicíny a hledání rovnováhy mezi tělem a myslí. Jako studentka upřednostňuji
					efektivní řešení, která nebolí mě ani peněženku. Velkou částí mého života je moje border kolie, se
					kterou se věnujeme psím sportům a podnikáme dobrodružné výlety do hor.</p>
				<p>Pohyb v přírodě je pro mě zdrojem energie i klidu. V kuchyni mě baví testovat různé stravovací styly
					a nové recepty, u kterých nepohrdnu kvalitní muzikou nebo zajímavým podcastem. Mou vášní je psaní a
					skrze něj chci sdílet své tipy, zkušenosti i drobné triky, které mohou ostatním pomoct ke
					spokojenějšímu životu.</p>
			</div>
		</div>
	</div>
</div>
							`,
						);
					}
					if (document.body.classList.contains("sk")) {
						$(this).replaceWith(
							`
<div id="blog-author">
	<div class="author-image"> <img src="https://www.natima.cz/user/documents/upload/Blog/autori/barbora_p_natima.jpg"
			alt="Barbora P." width="400" height="400"></div>
	<div class="author-text">
		<p class="author-label">Autor</p>
		<p class="author-name">Barbora P.</p>
		<div class="expandale author-text">
			<div class="expanding">
				<p>Zaujímam sa o cestu k zdraviu a pohode predovšetkým prirodzenou cestou. Objavujem silu byliniek,
					princípy tradičnej čínskej medicíny a hľadanie rovnováhy medzi telom a mysľou. Ako študentka
					uprednostňujem efektívne riešenia, ktoré nebolia mňa ani peňaženku. Veľkou súčasťou môjho života je
					moja border kólia, s ktorou sa venujeme psím športom a podnikáme dobrodružné výlety do hôr.</p>
				<p>Pohyb v prírode je pre mňa zdrojom energie aj pokoja. V kuchyni ma baví testovať rôzne stravovacie
					štýly a nové recepty, pri ktorých nepohrdnem kvalitnou muzikou alebo zaujímavým podcastom. Mojou
					vášňou je písanie a prostredníctvom neho chcem zdieľať svoje tipy, skúsenosti aj drobné triky, ktoré
					môžu ostatným pomôcť k spokojnejšiemu životu.</p>
			</div>
		</div>
	</div>
</div>
							`,
						);
					}
					if (document.body.classList.contains("pl")) {
						$(this).replaceWith(
							`
<div id="blog-author">
	<div class="author-image"> <img src="https://www.natima.cz/user/documents/upload/Blog/autori/barbora_p_natima.jpg"
			alt="Barbora P." width="400" height="400"></div>
	<div class="author-text">
		<p class="author-label">Autor</p>
		<p class="author-name">Barbara P.</p>
		<div class="expandale author-text">
			<div class="expanding">
				<p>Interesuję się drogą do zdrowia i dobrego samopoczucia przede wszystkim w naturalny sposób. Odkrywam
					moc ziół, zasady tradycyjnej medycyny chińskiej oraz poszukiwanie równowagi między ciałem a umysłem.
					Jako studentka stawiam na skuteczne rozwiązania, które nie obciążają ani mnie, ani mojego portfela.
					Dużą częścią mojego życia jest moja border collie, z którą uprawiamy psie sporty i wyruszamy na
					pełne przygód wycieczki w góry.</p>
				<p>Ruch na łonie natury jest dla mnie źródłem energii i spokoju. W kuchni uwielbiam eksperymentować z
					różnymi sposobami odżywiania i nowymi przepisami, a w tle najczęściej towarzyszy mi dobra muzyka lub
					ciekawy podcast. Moją pasją jest pisanie i właśnie poprzez nie chcę dzielić się swoimi wskazówkami,
					doświadczeniami oraz drobnymi trikami, które mogą pomóc innym żyć szczęśliwiej.</p>
			</div>
		</div>
	</div>
</div>
							`,
						);
					}
				}

				if (/##AUTOR##TEREZABERGLOWCOVA/i.test($(this).text())) {
					if (document.body.classList.contains("cs")) {
						$(this).replaceWith(
							`
<div id="blog-author">
	<div class="author-image"> <img src="https://www.natima.cz/user/documents/upload/Blog/autori/tereza_b_natima.jpg"
			alt="Tereza Berglowcová" width="400" height="400"></div>
	<div class="author-text">
		<p class="author-label">Autor</p>
		<p class="author-name">Tereza Berglowcová</p>
		<div class="expandale author-text">
			<div class="expanding">
				<p>Zajímám se o přírodní podporu zdraví prostřednictvím bylinek, výživy, pohybu a doplňků stravy. Blízký je mi aktivní životní styl, sport a přirozená péče o zdraví, stejně jako chvíle klidu a odpočinku s dobrou knihou.</p>
				<p>Jako maminka malé dcery hledám šetrné a přirozené cesty, jak podpořit imunitu a celkovou vitalitu celé rodiny. Nejbližší jsou mi přírodní produkty a šetrná řešení, která respektují potřeby organismu.</p>
				<p>Ráda se dělím o poznatky a zkušenosti, které mi dávají smysl a mohou být přínosné i pro ostatní.</p>
			</div>
		</div>
	</div>
</div>
							`,
						);
					}
					if (document.body.classList.contains("sk")) {
						$(this).replaceWith(
							`
<div id="blog-author">
	<div class="author-image"> <img src="https://www.natima.cz/user/documents/upload/Blog/autori/tereza_b_natima.jpg"
			alt="Tereza Berglowcová" width="400" height="400"></div>
	<div class="author-text">
		<p class="author-label">Autor</p>
		<p class="author-name">Tereza Berglowcová</p>
		<div class="expandale author-text">
			<div class="expanding">
			<p>Zaujímam sa o prírodnú podporu zdravia prostredníctvom byliniek, výživy, pohybu a výživových doplnkov. Blízky je mi aktívny životný štýl, šport a prirodzená starostlivosť o zdravie, rovnako ako chvíle pokoja a oddychu s dobrou knihou.</p>
<p>Ako mamička malej dcéry hľadám šetrné a prirodzené cesty, ako podporiť imunitu a celkovú vitalitu celej rodiny. Najbližšie sú mi prírodné produkty a šetrné riešenia, ktoré rešpektujú potreby organizmu.</p>
<p>Rada sa delím o poznatky a skúsenosti, ktoré mi dávajú zmysel a môžu byť prínosné aj pre ostatných.</p>

			</div>
		</div>
	</div>
</div>
							`,
						);
					}
					if (document.body.classList.contains("pl")) {
						$(this).replaceWith(
							`
<div id="blog-author">
	<div class="author-image"> <img src="https://www.natima.cz/user/documents/upload/Blog/autori/tereza_b_natima.jpg"
			alt="Tereza Berglowcová" width="400" height="400"></div>
	<div class="author-text">
		<p class="author-label">Autor</p>
		<p class="author-name">Tereza Berglowcová</p>
		<div class="expandale author-text">
			<div class="expanding">
			<p>Interesuję się naturalnym wspieraniem zdrowia poprzez zioła, odżywianie, ruch i suplementy diety. Bliski jest mi aktywny styl życia, sport i naturalna troska o zdrowie, a także chwile spokoju i odpoczynku z dobrą książką.</p>
<p>Jako mama małej córki szukam łagodnych i naturalnych sposobów na wspieranie odporności oraz ogólnej witalności całej rodziny. Najbliższe są mi produkty naturalne i delikatne rozwiązania, które szanują potrzeby organizmu.</p>
<p>Chętnie dzielę się wiedzą i doświadczeniami, które mają dla mnie sens i mogą być wartościowe także dla innych.</p>

			</div>
		</div>
	</div>
</div>
							`,
						);
					}
				}
			});
		}

		function generateId(text) {
			return text
				.normalize("NFD")
				.replace(/[\u0300-\u036f]/g, "")
				.replace(/\s+/g, "-")
				.toLowerCase();
		}

		function articleNav() {
			const content = document.querySelector("#content");
			const headings = Array.from(content.querySelectorAll("h2, h3, h4, h5"));
			const nav = document.createElement("div");
			nav.classList.add("article-nav");
			const navList = document.createElement("ul");

			let currentUl = navList;
			let lastLevel = 2;

			// Remove the last h3 from the list
			const lastH3Index = headings.map((h) => h.tagName).lastIndexOf("H3");
			if (lastH3Index !== -1) {
				headings.splice(lastH3Index, 1);
			}

			headings.forEach((heading) => {
				const level = parseInt(heading.tagName.substring(1));
				const id = generateId(heading.textContent);
				heading.id = id;

				const li = document.createElement("li");
				const a = document.createElement("a");
				a.href = `#${id}`;
				a.textContent = heading.textContent;
				li.appendChild(a);

				if (level > lastLevel) {
					const newUl = document.createElement("ul");
					currentUl.lastElementChild.appendChild(newUl);
					currentUl = newUl;
				} else if (level < lastLevel) {
					currentUl = navList;
					for (let i = 2; i < level; i++) {
						currentUl = currentUl.lastElementChild.querySelector("ul");
					}
				}

				currentUl.appendChild(li);
				lastLevel = level;
			});

			const articleContent = document.createElement("div");
			articleContent.classList.add("article-content");
			articleContent.appendChild(navList);

			const whatFind = document.createElement("div");
			whatFind.id = "open-article-nav";

			const span1whatFind = document.createElement("span");
			const span2whatFind = document.createElement("span");
			const spanShow = document.createElement("span");
			const spanHide = document.createElement("span");

			if (document.body.classList.contains("cs")) {
				span1whatFind.textContent = "Co v článku najdete?";
				spanShow.textContent = "Zobrazit seznam";
				spanHide.textContent = "Skrýt seznam";
			}
			if (document.body.classList.contains("sk")) {
				span1whatFind.textContent = "Čo v článku nájdete?";
				spanShow.textContent = "Zobraziť zoznam";
				spanHide.textContent = "Skryť zoznam";
			}
			if (document.body.classList.contains("pl")) {
				span1whatFind.textContent = "Co znajdziesz w artykule?";
				spanShow.textContent = "Pokaż listę";
				spanHide.textContent = "Ukryj listę";
			}

			whatFind.appendChild(span1whatFind);

			spanShow.classList.add("show-article");
			span2whatFind.appendChild(spanShow);

			spanHide.classList.add("hide-article");
			span2whatFind.appendChild(spanHide);

			whatFind.appendChild(span2whatFind);

			nav.appendChild(whatFind);
			nav.appendChild(articleContent);

			whatFind.addEventListener("click", function () {
				nav.classList.toggle("open");
			});

			// Insert after the first img in #content
			const firstImg = content.querySelector("img");
			if (firstImg) {
				const parent = firstImg.parentElement;
				parent.insertAdjacentElement("afterend", nav);
			} else {
				content.insertBefore(nav, content.firstChild);
			}

			document.querySelectorAll(".article-nav a").forEach((anchor) => {
				anchor.addEventListener("click", function (e) {
					e.preventDefault();
					const targetId = this.getAttribute("href").substring(1);
					const targetElement = document.getElementById(targetId);
					let offsetPosition = 0;
					if (!window.NAT.media.isMobile) {
						offsetPosition = targetElement.getBoundingClientRect().top + window.scrollY - 150;
					} else {
						offsetPosition = targetElement.getBoundingClientRect().top + window.scrollY - 80;
					}
					window.scrollTo({
						top: offsetPosition,
						behavior: "smooth",
					});
				});
			});
		}

		async function fetchAndAppendRelatedBlogs() {
			const blogURLs = [];
			const maxNumberOfBlogs = 5;

			$("#content p").each(function () {
				const text = $(this).text();
				if (/##BLOG##/i.test(text)) {
					const urlMatch = text.match(/https?:\/\/[^\s]+/);
					if (urlMatch && blogURLs.length < maxNumberOfBlogs) {
						blogURLs.push(urlMatch[0]);
					}
					$(this).remove();
					$("#content .next-prev").remove();
				}
			});

			if (blogURLs.length > 0) {
				const relatedBlogsDiv = $("<div>", { class: "blog-fetched-related" });
				let blogURL = "";
				let showBlogText = "";
				let showBlogHeadingText = "";

				if (document.body.classList.contains("cs")) {
					blogURL = "/blog/";
					showBlogText = "Zobrazit všechny články";
					showBlogHeadingText = "Mohlo by vás také zajímat";
				}
				if (document.body.classList.contains("sk")) {
					blogURL = "/blog/";
					showBlogText = "Zobraziť všetky články";
					showBlogHeadingText = "Mohlo by vás tiež zaujímať";
				}
				if (document.body.classList.contains("pl")) {
					blogURL = "/blog/";
					showBlogText = "Zobacz wszystkie artykuły";
					showBlogHeadingText = "Może Cię również zainteresować";
				}

				const showBlogButton = $("<div>", { class: "show-all-blog-btn" }).append(
					$("<a>", { href: blogURL, target: "_blank" }).text(showBlogText),
				);
				const showBlogHeading = $("<h3>", { class: "show-blog-heading" }).text(showBlogHeadingText);

				for (const url of blogURLs) {
					try {
						const response = await fetch(url);
						const text = await response.text();
						const parser = new DOMParser();
						const doc = parser.parseFromString(text, "text/html");
						const metaImage = doc.querySelector('meta[property="og:image"]').getAttribute("content");
						const metaSection = doc.querySelector('meta[property="article:section"]').getAttribute("content");
						let metaDescription = doc.querySelector('meta[itemprop="description"]').getAttribute("content");

						if (metaImage && metaSection && metaDescription) {
							// Create an anchor element
							const anchorElement = $("<a>", { href: url, target: "_blank" });

							// Create an img element
							const blogImage = $("<img>", {
								src: metaImage,
								alt: "Blog Image",
							});

							// Create a paragraph element for the meta section content
							const blogName = $("<h4>").text(metaSection);

							// Create a paragraph element for the meta description content
							metaDescription = metaDescription.replace(/&nbsp;/g, " ");
							const blogDescdription = $("<p>").text(metaDescription);

							// Append the img, section paragraph, and description paragraph elements to the anchor element
							anchorElement.append(blogImage);
							anchorElement.append(blogName);
							anchorElement.append(blogDescdription);

							// Append the anchor element to the relatedBlogsDiv
							relatedBlogsDiv.append(anchorElement);
						}
					} catch (error) {
						console.error("Error fetching related blog data:", error);
					}
				}

				// Append the relatedBlogsDiv to the body
				$(".content-wrapper-in").append(showBlogHeading);
				$(".content-wrapper-in").append(relatedBlogsDiv);
				$(".content-wrapper-in").append(showBlogButton);
				$(".content-wrapper-in").append($(".comments"));
				$(".content-wrapper-in").append($(".share"));
			}
		}

		async function fetchAndAppendBlogProducts() {
			const productURLs = [];
			let firstProductParagraph = null;
			const maxNumberOfProducts = 4;

			$("#content p").each(function () {
				const text = $(this).text();
				if (/##PRODUKT##/i.test(text)) {
					if (!firstProductParagraph) {
						firstProductParagraph = $(this);
					}
					const urlMatch = text.match(/https?:\/\/[^\s]+/);
					if (urlMatch && productURLs.length < maxNumberOfProducts) {
						productURLs.push(urlMatch[0]);
					}
				}
			});

			if (productURLs.length > 0 && firstProductParagraph) {
				const blogProductsDiv = $("<div>", { class: "blog-fetched-products" });

				for (const url of productURLs) {
					try {
						const response = await fetch(url);
						const text = await response.text();
						const parser = new DOMParser();
						const doc = parser.parseFromString(text, "text/html");
						const metaImage = doc.querySelector('meta[property="og:image"]');
						const metaName = doc.querySelector('meta[itemprop="name"]');

						if (metaImage && metaName) {
							// Create an anchor element
							const anchorElement = $("<a>", { href: url, target: "_blank" });

							// Create an img element
							const blogImage = $("<img>", {
								src: metaImage.getAttribute("content"),
								alt: "Product Image",
							});

							// Create a paragraph element for the meta name content
							const productName = $("<p>").text(metaName.getAttribute("content"));

							// Append the img element and the paragraph element to the anchor element
							anchorElement.append(blogImage);
							anchorElement.append(productName);

							// Append the anchor element to the blogProductsDiv
							blogProductsDiv.append(anchorElement);
						}
					} catch (error) {
						console.error("Error fetching product data:", error);
					}
				}

				// Insert the blogProductsDiv before the first found paragraph
				firstProductParagraph.before(blogProductsDiv);

				// Remove the paragraphs containing ##PRODUKT##
				$("p").each(function () {
					const text = $(this).text();
					if (/##PRODUKT##/i.test(text)) {
						$(this).remove();
					}
				});
			}
		}
		async function fetchAndAppendBlogProducts1() {
			const productURLs = [];
			let firstProductParagraph = null;
			const maxNumberOfProducts = 4;

			$("#content p").each(function () {
				const text = $(this).text();
				if (/##PRODUKT##1/i.test(text)) {
					if (!firstProductParagraph) {
						firstProductParagraph = $(this);
					}
					const urlMatch = text.match(/https?:\/\/[^\s]+/);
					if (urlMatch && productURLs.length < maxNumberOfProducts) {
						productURLs.push(urlMatch[0]);
					}
				}
			});

			if (productURLs.length > 0 && firstProductParagraph) {
				const blogProductsDiv = $("<div>", { class: "blog-fetched-products" });

				for (const url of productURLs) {
					try {
						const response = await fetch(url);
						const text = await response.text();
						const parser = new DOMParser();
						const doc = parser.parseFromString(text, "text/html");
						const metaImage = doc.querySelector('meta[property="og:image"]');
						const metaName = doc.querySelector('meta[itemprop="name"]');

						if (metaImage && metaName) {
							// Create an anchor element
							const anchorElement = $("<a>", { href: url, target: "_blank" });

							// Create a paragraph element for the meta name content
							const productName = $("<p>").text(metaName.getAttribute("content"));

							// Create an img element
							const blogImage = $("<img>", {
								src: metaImage.getAttribute("content"),
								alt: productName.text(),
								loading: "lazy",
							});

							// Append the img element and the paragraph element to the anchor element
							anchorElement.append(blogImage);
							anchorElement.append(productName);

							// Append the anchor element to the blogProductsDiv
							blogProductsDiv.append(anchorElement);
						}
					} catch (error) {
						console.error("Error fetching product data:", error);
					}
				}

				// Insert the blogProductsDiv before the first found paragraph
				firstProductParagraph.before(blogProductsDiv);

				// Remove the paragraphs containing ##PRODUKT##
				$("p").each(function () {
					const text = $(this).text();
					if (/##PRODUKT##1/i.test(text)) {
						$(this).remove();
					}
				});
			}
		}
		async function fetchAndAppendBlogProducts2() {
			const productURLs = [];
			let firstProductParagraph = null;
			const maxNumberOfProducts = 4;

			$("#content p").each(function () {
				const text = $(this).text();
				if (/##PRODUKT##2/i.test(text)) {
					if (!firstProductParagraph) {
						firstProductParagraph = $(this);
					}
					const urlMatch = text.match(/https?:\/\/[^\s]+/);
					if (urlMatch && productURLs.length < maxNumberOfProducts) {
						productURLs.push(urlMatch[0]);
					}
				}
			});

			if (productURLs.length > 0 && firstProductParagraph) {
				const blogProductsDiv = $("<div>", { class: "blog-fetched-products" });

				for (const url of productURLs) {
					try {
						const response = await fetch(url);
						const text = await response.text();
						const parser = new DOMParser();
						const doc = parser.parseFromString(text, "text/html");
						const metaImage = doc.querySelector('meta[property="og:image"]');
						const metaName = doc.querySelector('meta[itemprop="name"]');

						if (metaImage && metaName) {
							// Create an anchor element
							const anchorElement = $("<a>", { href: url, target: "_blank" });

							// Create a paragraph element for the meta name content
							const productName = $("<p>").text(metaName.getAttribute("content"));

							// Create an img element
							const blogImage = $("<img>", {
								src: metaImage.getAttribute("content"),
								alt: productName.text(),
								loading: "lazy",
							});

							// Append the img element and the paragraph element to the anchor element
							anchorElement.append(blogImage);
							anchorElement.append(productName);

							// Append the anchor element to the blogProductsDiv
							blogProductsDiv.append(anchorElement);
						}
					} catch (error) {
						console.error("Error fetching product data:", error);
					}
				}

				// Insert the blogProductsDiv before the first found paragraph
				firstProductParagraph.before(blogProductsDiv);

				// Remove the paragraphs containing ##PRODUKT##
				$("p").each(function () {
					const text = $(this).text();
					if (/##PRODUKT##2/i.test(text)) {
						$(this).remove();
					}
				});
			}
		}
		async function fetchAndAppendBlogProducts3() {
			const productURLs = [];
			let firstProductParagraph = null;
			const maxNumberOfProducts = 4;

			$("#content p").each(function () {
				const text = $(this).text();
				if (/##PRODUKT##3/i.test(text)) {
					if (!firstProductParagraph) {
						firstProductParagraph = $(this);
					}
					const urlMatch = text.match(/https?:\/\/[^\s]+/);
					if (urlMatch && productURLs.length < maxNumberOfProducts) {
						productURLs.push(urlMatch[0]);
					}
				}
			});

			if (productURLs.length > 0 && firstProductParagraph) {
				const blogProductsDiv = $("<div>", { class: "blog-fetched-products" });

				for (const url of productURLs) {
					try {
						const response = await fetch(url);
						const text = await response.text();
						const parser = new DOMParser();
						const doc = parser.parseFromString(text, "text/html");
						const metaImage = doc.querySelector('meta[property="og:image"]');
						const metaName = doc.querySelector('meta[itemprop="name"]');

						if (metaImage && metaName) {
							// Create an anchor element
							const anchorElement = $("<a>", { href: url, target: "_blank" });

							// Create a paragraph element for the meta name content
							const productName = $("<p>").text(metaName.getAttribute("content"));

							// Create an img element
							const blogImage = $("<img>", {
								src: metaImage.getAttribute("content"),
								alt: productName.text(),
								loading: "lazy",
							});

							// Append the img element and the paragraph element to the anchor element
							anchorElement.append(blogImage);
							anchorElement.append(productName);

							// Append the anchor element to the blogProductsDiv
							blogProductsDiv.append(anchorElement);
						}
					} catch (error) {
						console.error("Error fetching product data:", error);
					}
				}

				// Insert the blogProductsDiv before the first found paragraph
				firstProductParagraph.before(blogProductsDiv);

				// Remove the paragraphs containing ##PRODUKT##
				$("p").each(function () {
					const text = $(this).text();
					if (/##PRODUKT##3/i.test(text)) {
						$(this).remove();
					}
				});
			}
		}

		// NOTE: kept from original — fetchAndAppendBlogCategory is also called inside oldBlog()
		// for new posts, so on new posts it runs twice (both calls start concurrently)
		fetchAndAppendBlogCategory();
		async function fetchAndAppendBlogCategory() {
			const productRequests = [];
			const maxNumberOfProducts = 4;

			$("#content p").each(function () {
				const text = $(this).text();
				if (/##KATEGORIE##/i.test(text)) {
					const match = text.match(/##KATEGORIE##(\d+)\s+(https?:\/\/[^\s]+)/);
					if (match) {
						const numberOfProducts = Math.min(parseInt(match[1], 10), maxNumberOfProducts);
						const url = match[2];
						productRequests.push({ numberOfProducts, url, paragraph: $(this) });
					}
				}
			});

			if (productRequests.length > 0) {
				for (const request of productRequests) {
					const blogProductsDiv = $("<div>", { class: "blog-fetched-category" });

					try {
						const response = await fetch(request.url);
						const text = await response.text();
						const parser = new DOMParser();
						const doc = parser.parseFromString(text, "text/html");
						const products = doc.querySelectorAll("#products > .product");

						for (let i = 0; i < request.numberOfProducts && i < products.length; i++) {
							const product = products[i].cloneNode(true);

							// Replace src with data-src for all img elements
							$(product)
								.find("img")
								.each(function () {
									const dataSrc = $(this).attr("data-src");
									if (dataSrc) {
										$(this).attr("src", dataSrc);
									}
								});
							$(product).find("a.image").append($(product).find(".p-in"));
							blogProductsDiv.append(product);
						}

						let showCategoryText = "";
						if (document.body.classList.contains("cs")) {
							showCategoryText = "Zobrazit vše";
						}
						if (document.body.classList.contains("sk")) {
							showCategoryText = "Zobraziť všetko";
						}
						if (document.body.classList.contains("pl")) {
							showCategoryText = "Zobacz wszystko";
						}

						// Create the show-all-blog-btn div with an anchor inside
						const showBlogButtonDiv = $("<div>", { class: "show-all-blog-btn" }).append(
							$("<a>", { href: request.url, target: "_blank" }).text(showCategoryText),
						);

						// Insert the blogProductsDiv before the paragraph containing ##KATEGORIE##
						request.paragraph.before(blogProductsDiv);

						// Insert the show-all-blog-btn div before the paragraph containing ##KATEGORIE##
						request.paragraph.before(showBlogButtonDiv);

						// Remove the paragraph containing ##KATEGORIE##
						request.paragraph.remove();
					} catch (error) {
						console.error("Error fetching blog products:", error);
					}
				}
			}
		}
	});
}
